/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 14:40:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 16:35:04
 */
import ColumnTypes from '@/utils/ColumnTypes';
const nickname = {
	key: 'nickname',
	label: '用户名称',
	type: ColumnTypes.TextCell,
	minWidth: '110',
	headerAlign: 'left',
	fixed: 'fixed',
	maxShowLength: 5,
};
const mobile = {
	key: 'mobile',
	label: '登录手机号',
	type: ColumnTypes.TextCell,
	minWidth: '140',
	headerAlign: 'left',
};
const wx = {
	key: 'socialUserDO',
	label: '绑定微信',
	type: () => import('./components/tableCells/deliveryCell.vue'),
	minWidth: '157',
	headerAlign: 'left',
	maxShowLength: 5,
};
const role = {
	key: 'role',
	label: '角色',
	type: () => import('./components/tableCells/labelCell.vue'),
	minWidth: '150',
	headerAlign: 'left',
};
const userType = {
	key: 'userType',
	label: '用户类型',
	type: () => import('./components/tableCells/userTypeCell.vue'),
	minWidth: '140',
	headerAlign: 'left',
};
const dept = {
	key: 'dept',
	label: '部门',
	type: ColumnTypes.TextCell,
	minWidth: '110',
	headerAlign: 'left',
	maxShowLength: 6,
};
const status = {
	key: 'status',
	label: '账号状态',
	type: () => import('./components/tableCells/promoteStateCell.vue'),
	status_field: 'status',
	minWidth: '100',
	headerAlign: 'left',
};
const createTime = {
	key: 'createTime',
	label: '创建时间',
	type: ColumnTypes.TextCell,
	minWidth: '180',
	headerAlign: 'left',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: ColumnTypes.TextCell,
	minWidth: '160',
	headerAlign: 'left',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '260',
	custom: {
		limited: 3,
	},
	headerAlign: 'left',
	mode: 'vertical',
	fixed: 'right',
};

export const columns = [nickname, mobile, wx, role, userType, dept, status, createTime, remark, operations];
